import React from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, count, size = 18, editable = false, onChange }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      {stars.map((s) => {
        const icon = (
          <Star
            size={size}
            strokeWidth={2.5}
            className={s <= Math.round(value) ? "text-gold" : "text-stone-300"}
            fill={s <= Math.round(value) ? "#E8B25C" : "none"}
          />
        );
        return editable ? (
          <button key={s} type="button" onClick={() => onChange?.(s)} data-testid={`star-${s}`}
            className="transition-transform active:scale-90 hover:scale-110 p-0.5">
            {icon}
          </button>
        ) : (
          <span key={s} className="inline-flex">{icon}</span>
        );
      })}
      {typeof count === "number" && (
        <span className="text-sm text-forest-500 ml-1 font-medium">
          {value ? value.toFixed(1) : "New"}{count ? ` (${count})` : ""}
        </span>
      )}
    </div>
  );
}
